import { Injectable } from '@angular/core';
import {BehaviorSubject} from 'rxjs';
import {Location} from '@angular/common';
import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class AuxiliarService {
  private transitionPageSubject = new BehaviorSubject(false);
  public transitionPageObservable = this.transitionPageSubject.asObservable();
  private toastSubject = new BehaviorSubject({});
  public toastObservable = this.toastSubject.asObservable();

  constructor(private location: Location) {
  }

  // function to check app location
  public currentPathIncludes(text: string[]): boolean {
    const path = this.location.path();
    return _.findIndex(text, (t: string): boolean => {
      return _.includes(_.split(path, '/'), t);
    }) !== -1;
  }

  // function to show transition page
  public showTransitionPage(): void {
    this.transitionPageSubject.next(true);
  }

  // function to hide transition page
  public hideTransitionPage(): void {
    this.transitionPageSubject.next(false);
  }

  // function to order objects
  public order(items: any, field: string, direction?: string): any {
    const dir: any = _.castArray(direction || 'asc');
    return _.orderBy(items, [(item: any): string => {
      return _.deburr(_.get(item, field));
    }], dir);
  }

  // function to trigger toast message in app component
  public toast(message: string, type?: string): void {
    this.toastSubject.next({message, type});
  }
}
